import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * FAQ list with native disclosure animation.
 *
 * Props:
 *   - items: [{ q: string, a: ReactNode }]
 */
export default function Faq({ items }) {
  return (
    <div className="rounded-xl border border-border bg-card divide-y divide-border">
      {items.map((it, i) => (
        <FaqItem key={i} q={it.q} a={it.a} defaultOpen={i === 0} />
      ))}
    </div>
  );
}

function FaqItem({ q, a, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-start justify-between gap-3 px-5 py-4 text-left hover:bg-secondary/40 transition-colors"
      >
        <span className="font-display font-semibold text-foreground leading-snug">
          {q}
        </span>
        <ChevronDown
          className={`h-4 w-4 text-muted-foreground shrink-0 mt-1 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <div className="px-5 pb-5 -mt-1 text-muted-foreground leading-relaxed text-[15px] space-y-3 [&_a]:text-primary [&_a:hover]:underline [&_strong]:text-foreground">
          {a}
        </div>
      )}
    </div>
  );
}
